import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { ChildOption } from '../../models/child-option.model';
import { childAvatarFallbackLabel } from '../../helpers/child-avatar-fallback';

@Component({
  selector: 'app-parent-ai-child-dropdown',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './parent-ai-child-dropdown.component.html',
  styleUrl: './parent-ai-child-dropdown.component.scss',
})
export class ParentAiChildDropdownComponent {
  children = input<ChildOption[]>([]);
  selectedChildId = input<string | null>(null);
  /** When false, hides the general (non-child) option — used on child-scoped dashboards. */
  showNeutralOption = input(true);

  selectChild = output<ChildOption>();
  selectNeutral = output<void>();

  protected fallbackLabel(child: ChildOption): string {
    return childAvatarFallbackLabel(child);
  }
}
